"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resourceExists = exports.getResource = exports.defineResources = exports.setDefaultLocale = exports.Resources = void 0;
var helpers_1 = require("./helpers");
/**
 * The dictionary of localized resource messages
 */
exports.Resources = {};
function mapContainsResource(resources, locale, name) {
    return helpers_1.hasOwnProperty(resources, locale) && helpers_1.hasOwnProperty(resources[locale], name);
}
/**
 * The default locale, can be changed via `setDefaultLocale(locale)`.
 */
var defaultLocale = null;
/**
 * Sets the default locale
 * @param locale The default locale
 */
function setDefaultLocale(locale) {
    defaultLocale = locale;
}
exports.setDefaultLocale = setDefaultLocale;
/**
 * Globally defined resources
 */
var globalResources = {};
/**
 * Globally define localized resource messages for the given locale
 * @param locale The locale to set messages for
 * @param resources The resources messages
 */
function defineResources(locale, resources) {
    globalResources[locale] = helpers_1.hasOwnProperty(globalResources, locale) ? helpers_1.merge(globalResources[locale], resources) : resources;
}
exports.defineResources = defineResources;
// eslint-disable-next-line no-redeclare
function getResource(name, arg2, arg3) {
    var customResources;
    var locale;
    if (arguments.length === 2) {
        if (typeof arg2 === "object") {
            customResources = arg2;
            locale = null;
        }
        else if (typeof arg2 === "string") {
            customResources = null;
            locale = arg2;
        }
    }
    else if (arguments.length >= 3) {
        customResources = arg2;
        locale = arg3;
    }
    if (!locale)
        locale = defaultLocale || "en";
    var res;
    if (customResources && mapContainsResource(customResources, locale, name))
        res = customResources[locale][name];
    else if (mapContainsResource(globalResources, locale, name))
        res = globalResources[locale][name];
    else
        throw new Error("Resource '" + name + "' is not defined for locale '" + locale + "'.");
    return res;
}
exports.getResource = getResource;
function resourceExists(name, customResources, locale) {
    if (!locale)
        locale = defaultLocale || "en";
    return mapContainsResource(globalResources, locale, name) || (customResources && mapContainsResource(customResources, locale, name));
}
exports.resourceExists = resourceExists;
